var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSemiround01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 423 520",
    style: {
      enableBackground: "new 0 0 423 520"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st130{fill:#FFFFFF;}\n\t.st129{fill:none;stroke:#010101;stroke-width:3;stroke-miterlimit:10;}\n\t.st128{fill:#FFFFFF;stroke:#010101;stroke-width:3;stroke-miterlimit:10;}\n\t.st127{fill:#010101;}\n\t.st126{fill:#FFFFFF;stroke:#010101;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st130",
    d: "M112.49,118.94c-5.06,2.15-7.22,7.95-4.8,12.89c0,0,1.75,3.56,2.6,7.02c2.63,10.73,11.58,73.1,11.58,73.1 c0.78,5.44,2.66,9.95,4.18,10.02c1.52,0.07,4.26,3.96,6.28,7.34c0,0,0,0,1.72,6.13c2.41,8.58,1.59,14.93,1.24,20.4 c-0.98,15.03,0.95,19.03,0.99,33.38c0.05,18.86-10.39,107.4-10.39,107.4c-0.64,5.46,3.27,10.64,8.7,11.5l50.47,8.65 c5.43,0.86,11.21-2.72,12.84-7.98c0,0,10.28-33.08,10.27-55.62c-0.05-78.89-0.47-226.65-0.47-226.65 c-0.02-5.5-0.53-10.2-1.15-10.45s-2.18-0.6-2.18-0.24s-4.33-0.58-9.62-2.08l-14.59-7.92c-3.65-4.11-6.83-7.9-7.05-8.42 c-0.23-0.52-0.59-1.73-0.59-2.55c0-0.83-4.14,0.26-9.2,2.41L112.49,118.94z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st129",
    d: "M112.49,118.94c-5.06,2.15-7.22,7.95-4.8,12.89c0,0,1.75,3.56,2.6,7.02c2.63,10.73,11.58,73.1,11.58,73.1 c0.78,5.44,2.66,9.95,4.18,10.02c1.52,0.07,4.26,3.96,6.28,7.34c0,0,0,0,1.72,6.13c2.41,8.58,1.59,14.93,1.24,20.4 c-0.98,15.03,0.95,19.03,0.99,33.38c0.05,18.86-10.39,107.4-10.39,107.4c-0.64,5.46,3.27,10.64,8.7,11.5l50.47,8.65 c5.43,0.86,11.21-2.72,12.84-7.98c0,0,10.28-33.08,10.27-55.62c-0.05-78.89-0.47-226.65-0.47-226.65 c-0.02-5.5-0.53-10.2-1.15-10.45s-2.18-0.6-2.18-0.24s-4.33-0.58-9.62-2.08l-14.59-7.92c-3.65-4.11-6.83-7.9-7.05-8.42 c-0.23-0.52-0.59-1.73-0.59-2.55c0-0.83-4.14,0.26-9.2,2.41L112.49,118.94z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st130",
    d: "M84.42,396.85c0.11,5.5,4.7,10,10.2,10h14.66c5.5,0,10-4.5,9.99-10c0,0-0.05-94.73,7.35-152 c0.98-7.58,2.04-15.08,3.17-22.49c0.16-1.06,0.16-1.06,0.16-1.06c0.18-1.17-0.35-6.57-1.17-12.01c0,0-9.42-62.04-12.05-72.77 c-0.85-3.46-3-11.97-6.32-13.71c-0.26-0.14-0.52-0.24-0.79-0.29c-1.94-0.36-1.94-0.36-1.94-0.36c-1.56,2.64-3.61,9.23-4.55,14.65 c0,0-12.1,69.66-15.85,115.37C82.64,308.89,84.42,396.85,84.42,396.85z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st129",
    d: "M84.42,396.85c0.11,5.5,4.7,10,10.2,10h14.66c5.5,0,10-4.5,9.99-10c0,0-0.05-94.73,7.35-152 c0.98-7.58,2.04-15.08,3.17-22.49c0.16-1.06,0.16-1.06,0.16-1.06c0.18-1.17-0.35-6.57-1.17-12.01c0,0-9.42-62.04-12.05-72.77 c-0.85-3.46-3-11.97-6.32-13.71c-0.26-0.14-0.52-0.24-0.79-0.29c-1.94-0.36-1.94-0.36-1.94-0.36c-1.56,2.64-3.61,9.23-4.55,14.65 c0,0-12.1,69.66-15.85,115.37C82.64,308.89,84.42,396.85,84.42,396.85z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st128",
    d: "M202.23,115.49v0.04c-0.17,0.07-0.34,0.14-0.52,0.21L202.23,115.49z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st130",
    d: "M295.97,118.94c5.06,2.15,7.22,7.95,4.8,12.89c0,0-1.75,3.56-2.6,7.02c-2.63,10.73-11.58,73.1-11.58,73.1 c-0.78,5.44-2.66,9.95-4.18,10.02s-4.26,3.96-6.28,7.34c0,0,0,0-1.72,6.13c-2.41,8.58-1.59,14.93-1.24,20.4 c0.98,15.03-0.95,19.03-0.99,33.38c-0.05,18.86,10.39,107.4,10.39,107.4c0.64,5.46-3.27,10.64-8.7,11.5l-50.47,8.65 c-5.43,0.86-11.21-2.72-12.84-7.98c0,0-10.28-33.08-10.27-55.62c0.05-78.89,0.47-226.65,0.47-226.65 c0.02-5.5,0.53-10.2,1.15-10.45s2.18-0.6,2.18-0.24s4.33-0.58,9.62-2.08l14.59-7.92c3.65-4.11,6.83-7.9,7.05-8.42 c0.23-0.52,0.59-1.73,0.59-2.55c0-0.83,4.14,0.26,9.2,2.41L295.97,118.94z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st129",
    d: "M295.97,118.94c5.06,2.15,7.22,7.95,4.8,12.89c0,0-1.75,3.56-2.6,7.02c-2.63,10.73-11.58,73.1-11.58,73.1 c-0.78,5.44-2.66,9.95-4.18,10.02s-4.26,3.96-6.28,7.34c0,0,0,0-1.72,6.13c-2.41,8.58-1.59,14.93-1.24,20.4 c0.98,15.03-0.95,19.03-0.99,33.38c-0.05,18.86,10.39,107.4,10.39,107.4c0.64,5.46-3.27,10.64-8.7,11.5l-50.47,8.65 c-5.43,0.86-11.21-2.72-12.84-7.98c0,0-10.28-33.08-10.27-55.62c0.05-78.89,0.47-226.65,0.47-226.65 c0.02-5.5,0.53-10.2,1.15-10.45s2.18-0.6,2.18-0.24s4.33-0.58,9.62-2.08l14.59-7.92c3.65-4.11,6.83-7.9,7.05-8.42 c0.23-0.52,0.59-1.73,0.59-2.55c0-0.83,4.14,0.26,9.2,2.41L295.97,118.94z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st128",
    d: "M172.52,90.35l-1,2c0.04,0.19-0.05,0.81,0,1c2.93,14.03,16.77,21.63,31.85,22.13v-12.81 c-11.72-0.38-23.43-6.88-28.72-16.32C173.52,87.35,173.52,88.35,172.52,90.35z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st128",
    d: "M236.37,90.35l1,2c-0.04,0.19,0.05,0.81,0,1c-2.93,14.03-16.77,21.63-31.85,22.13v-12.81 c11.72-0.38,23.43-6.88,28.72-16.32C235.37,87.35,235.37,88.35,236.37,90.35z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st128",
    d: "M207.08,115.49v0.04c0.17,0.07,0.34,0.14,0.52,0.21L207.08,115.49z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st130",
    d: "M324.03,396.85c-0.11,5.5-4.7,10-10.2,10h-14.66c-5.5,0-10-4.5-9.99-10c0,0,0.05-94.73-7.35-152 c-0.98-7.58-2.04-15.08-3.17-22.49c-0.16-1.06-0.16-1.06-0.16-1.06c-0.18-1.17,0.35-6.57,1.17-12.01c0,0,9.42-62.04,12.05-72.77 c0.85-3.46,3-11.97,6.32-13.71c0.26-0.14,0.52-0.24,0.79-0.29c1.94-0.36,1.94-0.36,1.94-0.36c1.56,2.64,3.61,9.23,4.55,14.65 c0,0,12.1,69.66,15.85,115.37C325.81,308.89,324.03,396.85,324.03,396.85z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st129",
    d: "M324.03,396.85c-0.11,5.5-4.7,10-10.2,10h-14.66c-5.5,0-10-4.5-9.99-10c0,0,0.05-94.73-7.35-152 c-0.98-7.58-2.04-15.08-3.17-22.49c-0.16-1.06-0.16-1.06-0.16-1.06c-0.18-1.17,0.35-6.57,1.17-12.01c0,0,9.42-62.04,12.05-72.77 c0.85-3.46,3-11.97,6.32-13.71c0.26-0.14,0.52-0.24,0.79-0.29c1.94-0.36,1.94-0.36,1.94-0.36c1.56,2.64,3.61,9.23,4.55,14.65 c0,0,12.1,69.66,15.85,115.37C325.81,308.89,324.03,396.85,324.03,396.85z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st127",
    cx: 210.19,
    cy: 258.55,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st127",
    cx: 210.19,
    cy: 302.95,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st127",
    cx: 210.19,
    cy: 347.35,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st127",
    cx: 210.19,
    cy: 125.35,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st127",
    cx: 210.19,
    cy: 169.75,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st127",
    cx: 210.19,
    cy: 214.15,
    r: 5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st126",
    points: "272.78,319.87 272.65,319.88 271.67,300.87 234.33,302.2 234.33,299.76 271.67,298.42  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M272.78,322.31l-31.23,2.54c-3.89,0.32-7.22-2.75-7.22-6.65v-16l37.34-1.33l0.98,19.01L272.78,322.31z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st126",
    x1: 249.22,
    y1: 219.2,
    x2: 248.11,
    y2: 298.42
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st126",
    points: "135.33,321.87 135.46,321.88 136.44,302.87 173.78,304.2 173.78,301.76 136.44,300.42  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M135.33,324.31l31.23,2.54c3.89,0.32,7.22-2.75,7.22-6.65v-16l-37.34-1.33l-0.98,19.01L135.33,324.31z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st126",
    x1: 158.89,
    y1: 221.2,
    x2: 160,
    y2: 300.42
  })), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M229.4,168.45c9.7-0.37,28.3-2.39,38-2.76c0,3.63,0,7.26,0,10.89c-12.07,1.19-28.93,2.68-41,3.87 C227.4,175.45,228.4,172.45,229.4,168.45z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSemiround01);
export default __webpack_public_path__ + "static/media/semi round-01.1455c7c9f57db5bc36b40c7ff9aee9a9.svg";
export { ForwardRef as ReactComponent };